export default defineNuxtRouteMiddleware(async () => {
  const authStore = useAuthStore()
  const token = useCookie('token')

  // Sem token, ou sessão já carregada → nada a fazer
  if (!token.value || authStore.user)
    return

  // Probe via useHttpApi: não dispara toast nem redirect p/ /signout
  await authStore.getSession()

  // Token inválido/expirado (ex.: revogado pós-deploy) → limpa o cookie e segue
  // para a página pública, em vez de prender o usuário em /signout
  if (!authStore.user)
    useAuthToken().clearToken()
})
